<template>
  <div class="bar-list">
    <div v-if="!rows.length" class="bar-empty">暂无数据</div>
    <div v-for="row in shownRows" :key="row.key || row.label" class="bar-row" :style="gridStyle">
      <div class="bar-label" :class="row.labelClass">{{ row.label }}</div>
      <div class="bar-track">
        <template v-if="row.segs">
          <div v-for="(seg, idx) in row.segs" :key="idx" class="bar-fill"
               :style="{ width: seg.width + '%', background: seg.color }" :title="seg.title"></div>
        </template>
        <div v-else class="bar-fill" :style="{ width: row.width + '%', background: row.color || defaultColor }"></div>
      </div>
      <div class="bar-total">
        <b>{{ row.valueText }}</b><span v-if="unit"> {{ unit }}</span>
        <span v-if="row.extra" class="bar-extra" :class="row.extraClass"> · {{ row.extra }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { num, fmtNum } from './impact'

export default {
  name: 'BarList',
  props: {
    rows: { type: Array, default: function () { return [] } },
    unit: { type: String, default: '人' },
    labelWidth: { type: Number, default: 84 },
    rightWidth: { type: Number, default: 110 },
    defaultColor: { type: String, default: '#5C78A8' }
  },
  computed: {
    gridStyle () {
      return { gridTemplateColumns: this.labelWidth + 'px minmax(0, 1fr) ' + this.rightWidth + 'px' }
    },
    shownRows () {
      let max = 0
      this.rows.forEach(function (row) {
        let total = row.segs ? row.segs.reduce(function (n, s) { return n + num(s.value) }, 0) : num(row.value)
        if (total > max) {
          max = total
        }
      })
      max = max || 1
      return this.rows.map(function (row) {
        let out = Object.assign({}, row)
        out.valueText = row.valueText != null ? row.valueText : fmtNum(row.value)
        if (row.segs) {
          out.segs = row.segs.map(function (s) {
            return Object.assign({}, s, { width: Math.round(num(s.value) / max * 1000) / 10 })
          })
        } else if (row.percent != null) {
          out.width = Math.max(0, Math.min(100, num(row.percent)))
        } else {
          out.width = Math.round(num(row.value) / max * 1000) / 10
        }
        return out
      })
    }
  }
}
</script>
<style scoped lang="less">
@import './vars.less';

.bar-row {
  display: grid;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.bar-label {
  font-size: 12px;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: @text-sub;
  &.is-danger {
    font-weight: 600;
    color: @danger;
  }
  &.is-muted {
    color: @text-desc;
  }
}

.bar-track {
  display: flex;
  height: 22px;
  border-radius: 4px;
  background: @track;
  overflow: hidden;
}

.bar-fill {
  height: 100%;
  transition: width .3s;
}

.bar-total {
  font-size: 12px;
  white-space: nowrap;
  color: @text-muted;
  b {
    font-weight: 600;
    color: @text;
  }
}

.bar-extra.is-danger {
  font-weight: 600;
  color: @danger;
}

.bar-empty {
  padding: 24px 0;
  text-align: center;
  font-size: 12px;
  color: @text-muted;
}
</style>



// WEBPACK FOOTER //
// BarList.vue?71c6594b